import React, { useState } from 'react';
import { numbersOnly } from '../utils/inputValidation';
import styles from '../css-isolated/hr_drugs_history.module.css';


function DrugsHistory({ values = {}, onChange, isDarkMode = false, activeSection: externalActiveSection, setActiveSection: externalSetActiveSection }) {
  // Active section state (1 = Alcohol History, 2 = Smoking History, 3 = Drugs History)
  // Use external state if provided (from HRWizard), otherwise use internal state
  const [internalActiveSection] = useState(1);
  const activeSection = externalActiveSection !== undefined ? externalActiveSection : internalActiveSection;

  const defaultFormData = {
    alcoholDrinker: '',
    alcoholAgeAtOnset: '',
    alcoholFrequencyPerWeek: '',
    alcoholVolumeConsumed: '',
    alcoholTypeOfDrinks: '',
    smokingStatus: '',
    smokingAgeAtOnset: '',
    cigarettesPerDay: '',
    useOfIllicitDrugs: '',
    drugsAgeAtOnset: '',
    injectingDrugs: '',
    multipleDrugsAtOnce: '',
    primary_use: '',
    pri_frequency: '',
    pri_last_intake: '',
    secondary_use: '',
    sec_frequency: '',
    sec_last_intake: '',
    other_use: '',
    oth_frequency: '',
    oth_last_intake: ''
  };
  const formData = { ...defaultFormData, ...values };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updated = { ...formData, [name]: value };

    // Clear dependent fields if set to 'No' or 'Never smoked'
    if (name === 'alcoholDrinker' && value === 'No') {
      updated = {
        ...updated,
        alcoholAgeAtOnset: '',
        alcoholFrequencyPerWeek: '',
        alcoholVolumeConsumed: '',
        alcoholTypeOfDrinks: ''
      };
    }
    if (name === 'smokingStatus' && value === 'Never smoked') {
      updated = {
        ...updated,
        smokingAgeAtOnset: '',
        cigarettesPerDay: ''
      };
    }
    if (name === 'useOfIllicitDrugs' && value === 'No') {
      updated = {
        ...updated,
        drugsAgeAtOnset: '',
        injectingDrugs: '',
        multipleDrugsAtOnce: '',
        primary_use: '',
        pri_frequency: '',
        pri_last_intake: '',
        secondary_use: '',
        sec_frequency: '',
        sec_last_intake: '',
        other_use: '',
        oth_frequency: '',
        oth_last_intake: ''
      };
    }
    // Clear drug use details if user selects 'No' for multiple drugs at once
    if (name === 'multipleDrugsAtOnce' && value === 'No') {
      updated = {
        ...updated,
        primary_use: '',
        pri_frequency: '',
        pri_last_intake: '',
        secondary_use: '',
        sec_frequency: '',
        sec_last_intake: '',
        other_use: '',
        oth_frequency: '',
        oth_last_intake: ''
      };
    }
    onChange && onChange(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Let wizard handle submit
  };

  return (
    <div className={`${styles['hr-wizard-container']} ${isDarkMode ? styles['dark-mode'] : styles['light-mode']}`}>
      <form onSubmit={handleSubmit} autoComplete="off">
        {/* Section 1: Alcohol History */}
        {activeSection === 1 && (
            <div className={styles.formSection}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionIcon}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12V7a1 1 0 011-1h4a1 1 0 011 1v5M5 12l1.5 6h3l1.5-6M5 12h6m0 0l1.5 6h3L17 12m0 0V7a1 1 0 011-1h4a1 1 0 011 1v5m-6 0h6" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <h2 className={styles.sectionTitle}>Alcohol History</h2>
              </div>
              <div className={styles.formGrid}>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Drinker:</label>
                    <div className={styles.radioGroup}>
                      {['Yes', 'No'].map(option => (
                        <label key={option} className={styles.radioOption}>
                          <input
                            type="radio"
                            name="alcoholDrinker"
                            value={option}
                            checked={formData.alcoholDrinker === option}
                            onChange={handleInputChange}
                            className={styles.radioInput}
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Age at onset:</label>
                    <input
                      type="number"
                      name="alcoholAgeAtOnset"
                      value={formData.alcoholAgeAtOnset}
                      onChange={handleInputChange}
                      className={styles.formInput}
                      placeholder="Enter age"
                      disabled={formData.alcoholDrinker !== 'Yes'}
                      step="1"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Frequency/week:</label>
                    <input
                      type="text"
                      name="alcoholFrequencyPerWeek"
                      value={formData.alcoholFrequencyPerWeek}
                      onChange={handleInputChange}
                      className={styles.formInput}
                      placeholder="e.g., 3 times"
                      disabled={formData.alcoholDrinker !== 'Yes'}
                    />
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Volume consumed:</label>
                    <input
                      type="text"
                      name="alcoholVolumeConsumed"
                      value={formData.alcoholVolumeConsumed}
                      onChange={handleInputChange}
                      className={styles.formInput}
                      placeholder="e.g., 2 bottles"
                      disabled={formData.alcoholDrinker !== 'Yes'}
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Type of drinks:</label>
                    <input
                      type="text"
                      name="alcoholTypeOfDrinks"
                      value={formData.alcoholTypeOfDrinks}
                      onChange={handleInputChange}
                      className={styles.formInput}
                      placeholder="e.g., beer, wine"
                      disabled={formData.alcoholDrinker !== 'Yes'}
                    />
                  </div>
                  <div className={styles.formGroup}>
                    
                  </div>
                </div>
              </div>
            </div>
            )}
            {/* Section 2: Smoking History */}
            {activeSection === 2 && (
            <div className={styles.formSection}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionIcon}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12h12m0 0l-3-3m3 3l-3 3m9-3a4 4 0 00-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </div>
                <h2 className={styles.sectionTitle}>Smoking History</h2>
              </div>
              <div className={styles.formGrid}>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <div className={styles.smokingRadioContainer}>
                      <label className={styles.formLabel}>Status:</label>
                      {[
                        'Never smoked',
                        'Current smoker',
                        'Passive smoker',
                        'Stopped > a year',
                        'Stopped < a year'
                      ].map(option => (
                        <label key={option} className={styles.radioOption}>
                          <input
                            type="radio"
                            name="smokingStatus"
                            value={option}
                            checked={formData.smokingStatus === option}
                            onChange={handleInputChange}
                            className={styles.radioInput}
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Age at onset:</label>
                    <input
                      type="number"
                      name="smokingAgeAtOnset"
                      value={formData.smokingAgeAtOnset}
                      onChange={handleInputChange}
                      className={styles.formInput}
                      placeholder="Enter age"
                      disabled={!['Current smoker','Passive smoker','Stopped > a year','Stopped < a year'].includes(formData.smokingStatus)}
                      step="1"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Sticks per day:</label>
                    <input
                      type="text"
                      name="cigarettesPerDay"
                      value={formData.cigarettesPerDay}
                      onChange={handleInputChange}
                      onKeyDown={numbersOnly}
                      className={styles.formInput}
                      placeholder="e.g., 10"
                      disabled={!['Current smoker','Passive smoker','Stopped > a year','Stopped < a year'].includes(formData.smokingStatus)}
                    />
                  </div>
                </div>
              </div>
            </div>
            )}
            {/* Section 3: Drugs History */}
            {activeSection === 3 && (
            <div className={styles.formSection}>
              <div className={styles.sectionHeader}>
                <div className={styles.sectionIcon}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" stroke="currentColor" strokeWidth="2"/>
                  </svg>
                </div>
                <h2 className={styles.sectionTitle}>Drugs History</h2>
              </div>
              <div className={styles.formGrid}>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Illicit drugs:</label>
                    <div className={styles.radioGroup}>
                      {['Yes', 'No'].map(option => (
                        <label key={option} className={styles.radioOption}>
                          <input
                            type="radio"
                            name="useOfIllicitDrugs"
                            value={option}
                            checked={formData.useOfIllicitDrugs === option}
                            onChange={handleInputChange}
                            className={styles.radioInput}
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Age at onset:</label>
                    <input
                      type="number"
                      name="drugsAgeAtOnset"
                      value={formData.drugsAgeAtOnset}
                      onChange={handleInputChange}
                      className={styles.formInput}
                      placeholder="Enter age"
                      disabled={formData.useOfIllicitDrugs !== 'Yes'}
                      step="1"
                    />
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Injecting drugs:</label>
                    <div className={styles.radioGroup}>
                      {['Yes', 'No'].map(option => (
                        <label key={option} className={styles.radioOption}>
                          <input
                            type="radio"
                            name="injectingDrugs"
                            value={option}
                            checked={formData.injectingDrugs === option}
                            onChange={handleInputChange}
                            disabled={formData.useOfIllicitDrugs !== 'Yes'}
                            className={styles.radioInput}
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.formLabel}>Multiple drugs:</label>
                    <div className={styles.radioGroup}>
                      {['Yes', 'No'].map(option => (
                        <label key={option} className={styles.radioOption}>
                          <input
                            type="radio"
                            name="multipleDrugsAtOnce"
                            value={option}
                            checked={formData.multipleDrugsAtOnce === option}
                            onChange={handleInputChange}
                            disabled={formData.useOfIllicitDrugs !== 'Yes'}
                            className={styles.radioInput}
                          />
                          <span>{option}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className={styles.formGroup}>
                    {/* Drug Use Details Table */}
                    <label className={styles.formLabel}>Drug Use Details:</label>
                    <div className={styles.drugDetailsTable}>
                      {/* Table Header */}
                      <div className={styles.drugTableHeader}>
                        <div className={`${styles.drugTableCell} ${styles.drugTableHeaderCell}`}>Type</div>
                        <div className={`${styles.drugTableCell} ${styles.drugTableHeaderCell}`}>Frequency</div>
                        <div className={`${styles.drugTableCell} ${styles.drugTableHeaderCell} ${styles.drugTableLastCell}`}>Last Intake</div>
                      </div>
                      {/* Table Rows */}
                      {[
                        { label: 'Primary', useField: 'primary_use', freqField: 'pri_frequency', intakeField: 'pri_last_intake' },
                        { label: 'Secondary', useField: 'secondary_use', freqField: 'sec_frequency', intakeField: 'sec_last_intake' },
                        { label: 'Other', useField: 'other_use', freqField: 'oth_frequency', intakeField: 'oth_last_intake' }
                      ].map((drugType, index) => (
                        <div key={drugType.label} className={`${styles.drugTableRow} ${index < 2 ? styles.drugTableRowBorder : ''}`}>
                          <div className={`${styles.drugTableCell} ${styles.drugTableInputCell}`}>
                            <input
                              type="text"
                              value={formData[drugType.useField]}
                              onChange={(e) => {
                                const updated = { ...formData, [drugType.useField]: e.target.value };
                                onChange && onChange(updated);
                              }}
                              className={styles.drugsTableInput}
                              placeholder={drugType.label}
                              disabled={formData.useOfIllicitDrugs !== 'Yes' || formData.multipleDrugsAtOnce !== 'Yes'}
                            />
                          </div>
                          <div className={`${styles.drugTableCell} ${styles.drugTableInputCell}`}>
                            <input
                              type="text"
                              value={formData[drugType.freqField]}
                              onChange={(e) => {
                                const updated = { ...formData, [drugType.freqField]: e.target.value };
                                onChange && onChange(updated);
                              }}
                              className={styles.drugsTableInput}
                              placeholder="Frequency"
                              disabled={formData.useOfIllicitDrugs !== 'Yes' || formData.multipleDrugsAtOnce !== 'Yes'}
                            />
                          </div>
                          <div className={`${styles.drugTableCell} ${styles.drugTableInputCell} ${styles.drugTableLastCell}`}>
                            <input
                              type="text"
                              value={formData[drugType.intakeField]}
                              onChange={(e) => {
                                const updated = { ...formData, [drugType.intakeField]: e.target.value };
                                onChange && onChange(updated);
                              }}
                              className={styles.drugsTableInput}
                              placeholder="Last intake"
                              disabled={formData.useOfIllicitDrugs !== 'Yes' || formData.multipleDrugsAtOnce !== 'Yes'}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className={styles.formGroup}></div>
                </div>
              </div>
            </div>
        )}

      </form>
    </div>
  );
}

export default DrugsHistory;